// this page created by akash-ak

import Input from '../../../../Core/Fields/Floating/Input';
import MultiFileInput from '../../../../Core/Fields/Floating/MultiFileInput';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab3 = ({vendor_list, vehicle_list, tabThreeFormData, onInputChange, errors }) => {
  const transportMethods = [
    { name: 'land' },
    { name: 'water' },
    { name: 'air' },
  ];
  
  return (
    <>
      <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
        <div className="col-12">
          <p className="boxLabel m-0">Vehicle Details</p>
        </div>

        <div className="d-flex" style={{ gap: '1rem', width: '100%' ,marginBottom : '12px'}}>
          <div style={{ flex: '1' }}>
            <Input
              id="vehicle_no"
              label="Vehicle No."
              style={{ height: "30px" }}
              value={tabThreeFormData.vehicle_no}
              onChange={(e) => onInputChange('vehicle_no', e.target.value)}
              className={errors?.vehicle_no ? 'error-border' : ''}
              readOnly
            />
            {errors?.vehicle_no && <div className="error-text">This field is required</div>}
          </div>

          <div style={{ flex: '1' }}>
            <Input
              type="date"
              id="vehicle_arrival_date"
              label="Vehicle Arrival Date"
              style={{ height: "30px" }}
              value={tabThreeFormData.vehicle_arrival_date}
              onChange={(e) => onInputChange('vehicle_arrival_date', e.target.value)}
              className={errors?.vehicle_arrival_date ? 'error-border' : ''}
              readOnly
            />
            {errors?.vehicle_arrival_date && <div className="error-text">This field is required</div>}
          </div>

          <div style={{ flex: '1' }}>
            <Input
              type="time"
              id="vehicle_arrival_time"
              label="Vehicle Arrival Time"
              style={{ height: "30px" }}
              value={tabThreeFormData.vehicle_arrival_time}
              onChange={(e) => onInputChange('vehicle_arrival_time', e.target.value)}
              className={errors?.vehicle_arrival_time ? 'error-border' : ''}
              readOnly
            />
            {errors?.vehicle_arrival_time && <div className="error-text">This field is required</div>}
          </div>
        </div>

        <div className="d-flex" style={{ gap: '1rem', width: '100%' ,marginBottom : '12px'}}>
          <div style={{ flex: '1' }}>
            <SelectSearch
              list={vehicle_list}
              label="Select Vehicle"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={tabThreeFormData.select_vehicle}
              onChange={(val) => onInputChange('select_vehicle', val)}
              className={errors?.select_vehicle ? 'error-border' : ''}
              readOnly
            />
            {errors?.select_vehicle && <div className="error-text">This field is required</div>}
          </div>

          <div style={{ flex: '1' }}>
            <SelectSearch
              list={transportMethods}
              label="Transport Method"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={tabThreeFormData.transport_method}
              onChange={(val) => onInputChange('transport_method', val)}
              readOnly
            />
          </div>

          <div style={{ flex: '1' }}>
            <Input
              id="driver_name"
              label="Driver Name"
              style={{ height: "30px" }}
              value={tabThreeFormData.driver_name}
              onChange={(e) => onInputChange('driver_name', e.target.value)}
              readOnly
            />
          </div>
        </div>

        <div className="d-flex" style={{ gap: '1rem', width: '100%',marginBottom : '12px' }}>
          <div style={{ flex: '1' }}>
            <SelectSearch
              list={vendor_list}
              label="Transporter"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={tabThreeFormData.transporter}
              onChange={(val) => onInputChange('transporter', val)}
              readOnly
            />
          </div>

          <div style={{ flex: '1' }}>
            <Input
              id="driver_mobile_no"
              label="Driver Mobile No."
              style={{ height: "30px" }}
              value={tabThreeFormData.driver_mobile_no}
              onChange={(e) => onInputChange('driver_mobile_no', e.target.value)}
              readOnly
            />
          </div>

          <div style={{ flex: '1' }}>
            <Input
              id="sh_weight"
              label="Shipment Weight"
              style={{ height: "30px" }}
              value={tabThreeFormData.sh_weight}
              onChange={(e) => onInputChange('sh_weight', e.target.value)}
              readOnly
            />
          </div>
        </div>

        <div className="d-flex" style={{ gap: '1rem', width: '100%',marginBottom : '12px' }}>
          <div style={{ flex: '1' }}>
            <Input
              id="vehicle_condition"
              label="Vehicle Condition/Remarks"
              style={{ height: "30px" }}
              value={tabThreeFormData.vehicle_condition}
              onChange={(e) => onInputChange('vehicle_condition', e.target.value)}
              readOnly
            />
          </div>
          <div style={{ flex: '1' }}>
            <MultiFileInput
              name="vehicle image"
              setFile={(files) => onInputChange("vehicle_image", files)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab3;